module.exports = __webpack_public_path__ + "static/img/index_06.08f923a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_06.png
// module id = dpFa
// module chunks = 1